'use strict';

angular.module('DoohApps')
.factory('PersonFilterData', function () {
    var DataFilter = {};

    DataFilter.SetDefault = function () {
        DataFilter.PersonFilter = {};
        DataFilter.PersonFilter.Offset = 0;
        DataFilter.PersonFilter.Count = 10;
        DataFilter.PersonFilter.search = '';
        DataFilter.PersonFilter.nameOrder = 0;
        DataFilter.PersonFilter.emailOrder = 0;
        DataFilter.PersonFilter.phoneOrder = 0;
        DataFilter.PersonFilter.userNameOrder = 0;
        DataFilter.PersonFilter.companyOrder = 0;
        DataFilter.PersonFilter.lastLoginOrder = 0;
        DataFilter.PersonFilter.statusOrder = 1;
        DataFilter.PersonFilter.roleOrder = 0;
        DataFilter.PersonFilter.rejected = false;
        DataFilter.PersonFilter.active = true;
        DataFilter.PersonFilter.unapproved = true;
        DataFilter.PersonFilter.approved = true;
        DataFilter.PersonFilter.TotalCount = 0;
        DataFilter.SelectedVoucher = {};
    };
    DataFilter.SetDefault();

    DataFilter.Clear = function () {
        DataFilter.SetDefault();
    }

    return DataFilter;
});